import { render, staticRenderFns } from "./TemperatureRangeLastXDays.vue?vue&type=template&id=2cc81f9d&"
import script from "./TemperatureRangeLastXDays.vue?vue&type=script&lang=ts&"
export * from "./TemperatureRangeLastXDays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports